import React, { useEffect, useMemo, useRef, useState } from 'react';
import  {Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
import style from './TabResults.module.less'
import { tableIcons } from "../../../../helpers";
import  {Link, NavLink, useParams } from "react-router-dom";
import { useStore } from "../../../../stores/StoreHelpers";
import ResultsHeader from "./ResultsHeader";
import MaterialTable, { MTableAction, MTableBodyRow, MTableCell, MTableHeader } from "material-table";
import { LocalizationWithSmallActions, mapFilesForModal, modifyDefaultOptions } from "../../../../helpers/table";
import './MileStonesTable.less'
import { ThreeDRotation } from "@material-ui/icons";
import MileStonesTable, { StyledTooltip } from "./MileStonesTable";
import useAPI from "../../../../hooks/useAPI";
import { monthsArray } from "../../../../stores/StratProject/StrategyStore";
import useToast from "../../../../hooks/useToast";
import { observer } from "mobx-react";
import { StrategyRequests } from "../../../../requests/StrategyRequests/strategyRequests";
import useUserContext from "../../../../hooks/useUserContext";
import { actionSwitcher } from "../../../../helpers/StrategyProject/stratProjectHelpers";

import { FileView } from "../../../UI/upload/FileInput";
import ModalProjectOfficeComment from "./ModalProjectOfficeComment";
import tableApproved from '../../../../../img/icons/tableApproved.svg'
import tableDeclined from '../../../../../img/icons/tableDeclined.svg'
import tableProjOffice from '../../../../../img/icons/tableProjOffice.svg'
import tableInProjOffice from '../../../../../img/icons/tableInProjOffice.svg'
import tableAchieved from '../../../../../img/icons/tableAchieved.svg'
import ImageStatus from "./ImageStatus";
import ModalDescription from "../../../common/ModalDescription";
import SlicedTableColumn from "./SlicedTableColumn";
import RenderResponsibleComponent from "./RenderResponsibleComponent";
import { useRequestObject } from "../../../../hooks/useRequestObject";
import FileTableComponent from "../../../FileTableIcon/FileTableComponent";
import { isAdmin, isStratAdmin } from "../../../../services/rolesSvc";
import { getPathType } from '../../../../helpers/typeProject'

const TabResults = observer(({data}) =>{
    const [resultPeriod,setResultPeriod] = useState('')
    const store = useStore()
    const api = useAPI()
    const resultExist = store.strategies.resultLength > 0
    const { stratId } = useParams();
    const addToast = useToast()
    const [filesModalOpen,setFilesModalOpen] = useState(null)
    const [resultModalOpen,setResultModalOpen] = useState(null)
    const [statusModalOpen,setStatusModalOpen] = useState(null)
    const [projectsModalOpen,setProjectsModalOpen] = useState(null)
    const [allTablesOpen,setAllTablesOpen] = useState({
        milestones: false,
        projMilestones: false
    })
	const [childProjects, setChildProjects] = useState([])
	const [projectsFilter, setProjectsFilter] = useState([])
    const requests = useRequestObject({classType:StrategyRequests, stratId, api, addToast, store})
    const userCtx = useUserContext();

    const tableDescription= [
        {icon:tableProjOffice,label:'На исполнении'},
        {icon:tableInProjOffice,label:'В проектном офисе'},
        {icon:tableApproved,label:'Одобрено'},
        {icon:tableAchieved,label:'Достигнут'},
        {icon:tableDeclined,label:'Отклонено'},
    ]

    useEffect(() => {
        if(store.strategies.planResults){
            const projects = store.strategies.planResults
                .reduce((acc, curr) => {
                    const childProjects = getProjectsByResult(curr)
                    return [...acc, ...childProjects]
                }, [])
                .reduce((acc, curr) => {
                    if(acc.some(value => value.fullNumber === curr.fullNumber)){
                        return acc
                    }
                    return [...acc, curr]
                }, [])
                .sort((a, b) => +a.fullNumber - +b.fullNumber)
            setChildProjects(projects)
        }
    }, [store.strategies.planResults])

    const materialTable = useMemo(()=>{
        const getColumns = () => {
            const cols = [
                {
                    title: 'Статус (факт)',
                    field: 'status',
                    editable: 'never',
                    render:(rowData)=> <ImageStatus onClick={()=>{setStatusModalOpen(rowData?.comment)}} status={rowData.status} comment={rowData?.comment}/>,
                    cellStyle: { width: "calc(5%)",minWidth: '5%',maxWidth: '5%' },

                },
                {
                    title: '№',
                    field: 'num',
                    editable: 'never',
                    cellStyle: { width: "3%",minWidth: '3%',maxWidth: '3%' },
                    render:(rowData)=><span style={{width:0,display:"block"}}>{rowData?.tableData?.path[0] + 1}.</span>
                },
                {
                    title: 'Планируемый результат',
                    field: 'name',
                    editable: 'never',
                    cellStyle: { width: "calc(18%)",minWidth: '18%',maxWidth: '18%' },
                    render:(rowData)=><span style={{display:"block",wordWrap:'break-word'}}>{rowData.name}</span>

                },
                {
                    title: 'Фактический результат',
                    field: 'result',
                    editable: 'never',
                    cellStyle: { width: "18%",minWidth: '18%',maxWidth: '18%'},
                    render:(rowData) => <SlicedTableColumn text={rowData?.result} onClick={()=>setResultModalOpen(rowData?.result)} />

                },

                {
                    title: 'Дата вып. (план)',
                    editable: 'never',
                    cellStyle: { width: "calc(10%)",minWidth: '10%',maxWidth: '10%' },
                    render:(rowData)=><>{rowData.monthPlan !== null && rowData.yearPlan ?`${monthsArray[rowData.monthPlan]}, ${rowData.yearPlan}`:'Не указано'}</>
                },
                {
                    title: 'Дата вып. (факт)',
                    render:(rowData)=><>{rowData.monthFact !== null && rowData.yearFact ? `${monthsArray[rowData.monthFact]}, ${rowData.yearFact}` : 'Не указано'}</>,
                    editable: 'never',
                    cellStyle: { width: "calc(10%)",minWidth: '10%',maxWidth: '10%'},
                },
                {
                    title: 'УГТ (план)',
                    editable: 'never',
                    cellStyle: { width: "calc(5%)",minWidth: '5%',maxWidth: '5%', whiteSpace:'nowrap' },
                    render:(rowData)=><>{rowData?.trlId ? <StyledTooltip arrow title={store.strategies.trls.find(x=>x.id===rowData.trlId)?.descr}><span style={{fontSize: '14px', textDecoration: 'underline'}}>{rowData.trlId}</span></StyledTooltip > :'-'}</>,
                },
                {
                    title: 'УГТ (факт)',
                    cellStyle: { width: "calc(5%)",minWidth: '5%', whiteSpace:'nowrap',maxWidth: '5%' },
                    editable: 'never',
                    render:(rowData)=><>{rowData?.trlFactId ? <StyledTooltip arrow title={store.strategies.trls.find(x=>x.id===rowData.trlFactId)?.descr}><span style={{fontSize: '14px', textDecoration: 'underline'}}>{rowData.trlFactId}</span></StyledTooltip > :'-'}</>,

                },
                {
                    title: 'Ответственный',
                    editable: 'never',
                    cellStyle: {width: "10%",minWidth: '10%',maxWidth: '10%'},
                    render:(rowData => <RenderResponsibleComponent rowData={rowData} />),
                },
                {
                    title: 'Проекты',
                    editable: 'never',
                    cellStyle: {width: "6%",minWidth: '6%',maxWidth: '6%'},
                    render:(rowData => <div className={style.projectsInTable} onClick={() => setProjectsModalOpen(rowData.projs)}>{rowData.projs.map(proj => <>{proj.fullNumber} <br/></>)}</div>),
                },
                {
                    title: 'Док. (шт.)',
                    field: 'files',
                    editable: 'never',
                    cellStyle: {
                        width: '5%',
                        minWidth: '5%',
                        maxWidth:'5%'
                    },
                    render:(rowData) => <FileTableComponent data={rowData?.files.length} onClick={()=>!!rowData?.files.length && setFilesModalOpen(rowData.files)}/>
                },
            ]
            return [...cols]
        }
        return ( 
            <MaterialTable
            	options={modifyDefaultOptions({
                overflowY:'hidden',
                overflowX:'hidden',
                rowStyle: rowData => ({
                    display:"flex",
                    backgroundColor: !rowData.parentId ? '#f5f5ff' : '#FFF',
                }),
                headerStyle:{
                    fontSize:'14px',
                    fontWeight:'600',
                    backgroundColor:'#D9DDF3'
                },
                paging: true,
                pageSize:10,
                padding:'default',
                filtering: false,
                tableLayout:'auto',
                toolbar:true,
            		})}
            	icons={tableIcons}
            	data={
                    store.strategies.planResults.filter(result => {
                        const childProjects = getProjectsByResult(result)
                        return projectsFilter.length === 0 || childProjects.some(proj => projectsFilter.some(filterProj => filterProj.fullNumber === proj.fullNumber))
                    })
                }
            	columns={getColumns()}
            	localization={LocalizationWithSmallActions}
            	components={{
                    Row:(props)=>{
				    	const tableData = {...props.data.tableData, path: props.path}
				    	props.data.tableData = tableData
                        return <tr>
                            <td colSpan="12" style={{display:'inline-flex', width:'100%'}}>
                                <table className={`w-100 ${style.tableRow}`}>
                                    <MTableBodyRow {...props} className = {style.tableRowDeletedBorders} />
                                    <MileStonesTable data={props.data} resultId={props.data.id} api={api} addToast={addToast} stratId={stratId} projectsFilter={projectsFilter} allTablesOpened={allTablesOpen} mode="milestones" type={data?.type}/>
				    			    <MileStonesTable data={props.data} resultId={props.data.id} api={api} addToast={addToast} stratId={stratId} projectsFilter={projectsFilter} allTablesOpened={allTablesOpen} mode="projMilestones" type={data?.type}/>
                                </table>
                            </td>
                        </tr>
                    },
                    Header:props => <div className={style.headerOverride}><MTableHeader {...props} /></div>,
                    Toolbar:()=> (<div style={{marginBottom:'15px'}}>
                        <ResultsHeader 
                            resultPeriod={resultPeriod}
                            store={store}
                            projectId = {stratId}
                            requests={requests}
                            childProjects={childProjects || []}
                            setProjectsFilter={setProjectsFilter}
                            selectedProjects={projectsFilter}
                            setAllTablesOpen={setAllTablesOpen}
                            type={data?.type}
                        />
                        <Row style={{marginTop:'50px'}}>
                            <Col className={`w-100`}>
                                <div className={'d-flex justify-content-between'}>
                                    <div className={'d-flex align-self-end'}>
                                        {tableDescription.map(x=>(
                                            <div>
                                                <img style={{marginRight:'8px'}} src={x.icon} alt={x.label}/>
                                                <span style={{marginRight:'15px'}}>{x.label}</span>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='d-flex gap-4'>
                                       <Accordion defaultActiveKey={`${allTablesOpen.milestones}`} flush onClick={()=>{
                                           store.strategies.changeAllTableStatus(!allTablesOpen.milestones, ['milestones'])
                                           setAllTablesOpen(prevState => ({...prevState, milestones: !prevState.milestones}))
                                       }}>
                                           <Accordion.Item eventKey={'true'} >
                                               <Accordion.Header className={`accordionHeader overrideHeader ${style.accordionHeaderOverride}`}>
                                                    {!!allTablesOpen.milestones ? 'Свернуть вехи результатов' : 'Развернуть вехи результатов'}
                                                </Accordion.Header>
                                            </Accordion.Item>
                                        </Accordion>
                                        <Accordion defaultActiveKey={`${allTablesOpen.projMilestones}`} flush onClick={()=>{
                                            store.strategies.changeAllTableStatus(!allTablesOpen.projMilestones, ['projMilestones'])
                                            setAllTablesOpen(prevState => ({...prevState, projMilestones: !prevState.projMilestones}))
                                        }}>
                                            <Accordion.Item eventKey={'true'} >
                                                <Accordion.Header className={`accordionHeader overrideHeader ${style.accordionHeaderOverride}`}>{!!allTablesOpen.projMilestones ? 'Свернуть вехи проектов' : 'Развернуть вехи проектов'}</Accordion.Header>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div> ),
                    Action: props => {
                        if (!props.action.custom) {
                            return <MTableAction {...props} />
                        }
                        else {
                            return actionSwitcher(props,userCtx,requests,stratId,null,(id,status,value)=>store.strategies.setCurrentCommentObject(id,status,value))
                        }
                    }
                }}
                actions={
                    [{
                        custom: true,
                        hidden: false,
                        icon: () => <ThreeDRotation style={{color: '#0D6EFD'}}/>,
                    }]
                }
            />
        )
    },[store.strategies.planResults,store.strategies.filters,store.strategies.openedTables, childProjects, projectsFilter, allTablesOpen])


    useEffect(()=>{
        if (store.strategies.trls.length === 0){
           requests.handleAddResult().catch()
        }
    },[])

    useEffect(()=>{
        store.strategies.getStrategyContainsResults(stratId)
            .then(x=>{
                if(!!x && x?.length !==0){
                     return requests.updateAllPlanResults()
                }
            })

    },[])

    const getCurrentStatus = () =>{
        switch (store.strategies.currentCommentObject?.status){
            case 'decline':
                return 'Отказ результата'
            case 'return':
                return 'Возврат результата'
            default:
                return ''
        }
    }

    const getFilesForModal = (isPlan=false) => {
        const files = Object.values(filesModalOpen ?? {}).filter(file=>file?.isPlan===isPlan)
        return mapFilesForModal(files,`Документы ${isPlan ? '(план)' : '(факт)'}`)

        // return (
        //     <div className={'mt-lg-2'}>
        //         <h3 style={{fontWeight:600}}>{`Документы ${isPlan ? '(план)' : '(факт)'}`}</h3>
        //         <div className={'mt-lg-4'}>
        //             {!!files.length ? files.map((x,y)=><FileView disabled={true} isDownloadable={true} item={x} index={y} />): <span className={style.noFiles}>—</span>}
        //         </div>
        //     </div>
        // )
    }

    const resultsExists = (
        <div className={`${style.styledTable} ${style.mainResultsTable}`}>
            {materialTable}
            {<ModalProjectOfficeComment
                show={!!store.strategies.currentCommentObject && !['approve', 'achieve'].includes(store.strategies.currentCommentObject.status)}
                onClose={()=>store.strategies.clearCurrentCommentObj()}
                headerText={getCurrentStatus()}
                onSubmit={(el)=>{
                    store.strategies.changeResultsComment(el)
                    requests.changeStatus(store.strategies.currentCommentObject.id,
                        store.strategies.currentCommentObject.status,store.strategies.currentCommentObject?.comment)
                }}
            />}
            {<ModalDescription headerText={'Приложенные документы'} onClose={()=>setFilesModalOpen(!filesModalOpen)} show={filesModalOpen}>
                <Container>
                    {getFilesForModal(true)}
                    {getFilesForModal(false)}
                </Container>
            </ModalDescription>}
            {<ModalDescription className={style.modalDescription} headerText={'Подробное описание'} onClose={()=>setResultModalOpen(null)} show={!!resultModalOpen}>
                <Container>
                    <span>{resultModalOpen || ''}</span>
                </Container>
            </ModalDescription>}
            {<ModalDescription className={style.modalDescription} headerText={'Причина отклонения'} onClose={()=>setStatusModalOpen(null)} show={!!statusModalOpen}>
                <Container>
                    <span>{statusModalOpen || ''}</span>
                </Container>
            </ModalDescription>}
            <ModalDescription className={style.modalDescription} headerText={'Проекты, влияющие на выполнение вехи'} onClose={() => setProjectsModalOpen(null)} show={!!projectsModalOpen}>
                <Container>
                    <ul className={style.projectsModalList}>
                        {(projectsModalOpen || []).map(proj => <li className={style.projectsModalItem}>
                             <NavLink to={`/strats/${proj.strategyId}/projs/${proj.id}`}>{proj.fullNumber} {proj.name}</NavLink>
                        </li>)}
                    </ul>
                </Container>
            </ModalDescription>
        </div>
    )
    const noResults = (
        <>
            <Row>
                {store.strategies.isStrategyContainsResults ? <>
                        <ResultsHeader
                            requests={requests}
                            resultPeriod={resultPeriod}
                            store={store}
                            projectId={stratId}
                            childProjects={childProjects || []}
                            selectedProjects={projectsFilter}
                            setProjectsFilter={setProjectsFilter}
                            setAllTablesOpen={setAllTablesOpen}
                            type={data?.type}
                        />
                    </> :
                    <Col sm={'2'}>
                        <NavLink to={`/${getPathType(data?.type)}/${data.id}/results/new`}>
                            {(isAdmin(userCtx) || isStratAdmin(userCtx, stratId)) &&
                                <Button variant="primary" className={style.button}>+ Добавить План</Button>}
                        </NavLink>
                    </Col>
                }
            </Row>
        </>

    )
    return resultExist ? resultsExists : noResults ;
});

export default TabResults;

function getProjectsByResult(result){
    const resultProjects = [...result.projs, ...(result.projMilestones || []).reduce((acc, projMilestone) => [...acc, ...(projMilestone.projs || [])], [])]
    const milestonesProjects = [...(result.milestones || [])].reduce((acc, milestone) => [
        ...acc, ...(milestone.projs || []), ...milestone.projMilestones.reduce((acc, projMilestone) => [...acc, ...(projMilestone.projs || [])], [])
    ], [])
    return [...resultProjects, ...milestonesProjects]
}